
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { formatCurrency } from './utils/formatters';

type ComparisonCardsProps = {
  totalCustomerSavings: number;
  totalRestaurantProfit: number;
  avgCustomerSavings: number;
  avgRestaurantProfit: number;
};

const ComparisonCards: React.FC<ComparisonCardsProps> = ({
  totalCustomerSavings,
  totalRestaurantProfit,
  avgCustomerSavings,
  avgRestaurantProfit,
}) => {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      <Card className="bg-brand-blue-light-5">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Profit Increase</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-brand-blue">
            {formatCurrency(totalRestaurantProfit)}
          </div>
          <p className="text-xs text-muted-foreground mt-1">
            vs. UberEats (delivery orders)
          </p>
        </CardContent>
      </Card>
      
      <Card className="bg-brand-blue-light-5">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Avg. Profit Increase</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-brand-blue">
            {formatCurrency(avgRestaurantProfit)}
          </div>
          <p className="text-xs text-muted-foreground mt-1">
            Per delivery order
          </p>
        </CardContent>
      </Card>
      
      <Card className="bg-brand-yellow-light-4">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Customer Savings</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-brand-yellow-dark-1">
            {formatCurrency(totalCustomerSavings)}
          </div>
          <p className="text-xs text-muted-foreground mt-1">
            vs. UberEats (delivery orders)
          </p>
        </CardContent>
      </Card>
      
      <Card className="bg-brand-yellow-light-4">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Avg. Customer Savings</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-brand-yellow-dark-1">
            {formatCurrency(avgCustomerSavings)}
          </div>
          <p className="text-xs text-muted-foreground mt-1">
            Per delivery order
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default ComparisonCards;
